import { PayloadAction } from '@reduxjs/toolkit';
import { PostMetadataDTO } from 'services/api/models/PostDTO';
import resetAll from 'store/shared/resetAll';
import createSlice from 'utils/@reduxjs/toolkit';
import { ContentState } from './types';

export const initialState: ContentState = {
  suggestedPosts: undefined,
};

const slice = createSlice({
  name: 'content',
  initialState,
  extraReducers: (builder: any) => builder.addCase(resetAll, () => initialState),
  reducers: {
    setSuggestedPosts: (state, action: PayloadAction<PostMetadataDTO[]>) => {
      state.suggestedPosts = action.payload;
    },
    // Forget the per-session list so the next visit fetches suggestions
    // computed from the user's updated interest profile
    clearSuggestedPosts: state => {
      state.suggestedPosts = undefined;
    },
    markPostAsRead: (state, action: PayloadAction<number>) => {
      state.suggestedPosts = state.suggestedPosts?.map(post =>
        post.id === action.payload ? { ...post, read: true } : post,
      );
    },
  },
});

/**
 * `actions` will be used to trigger change in the state from where ever you want
 */
export const { actions: contentActions, reducer: contentReducer } = slice;
